import { Button } from 'react-bootstrap'

import { headerToIcon } from '@/components/CardLists/CardView/Sidebar'
import CornerBackgroundImage from '@/components/Combo/CornerBackgroundImage/CornerBackgroundImage'
import Icon from '@/components/Icon/Icon'
import { CardListType } from '@/types/card'
import { ComboData } from '@/types/page'
import { artCrop } from '@/utils/images'

import styles from './MetaData.module.scss'

type Props = {
  cardLists?: CardListType[]
  combo: ComboData
}

const PlayedWith = ({ cardLists, combo }: Props) => {
  if (!cardLists) return
  return (
    <div className={styles.infoContainer}>
      {combo.cardIds[0] && <CornerBackgroundImage image={artCrop(combo.cardIds[0])} position='topRight' size={300} />}
      <h2 className={styles.header}>
        <Icon icon='link' />
        &nbsp;&nbsp;Played with this combo
      </h2>
      <div className={styles.statContainer}>
        {cardLists.slice(0, 4).map((cardList, i) => (
          <a href={`#${i === 0 ? 'cardlists' : cardList.tag}`} key={cardList.tag}>
            <Button className='link-button' variant='outline-primary'>
              {headerToIcon(cardList.header)} {cardList.header}
            </Button>
          </a>
        ))}
      </div>
    </div>
  )
}

export default PlayedWith
